import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  info: null,
  currentLanguage: null,
  countries: [],
  columnsPreferences: {},
};

export const authSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setInfoData(state, { payload: userData }) {
      state.info = userData;
    },
    setCountryData(state, { payload: countryData }) {
      state.countries = countryData;
    },
    setColumnsPerferecnes(state, { payload: columns }) {
      state.columnsPreferences = columns;
    },
  },
});

export const { setInfoData, setCountryData, setColumnsPerferecnes } = authSlice.actions;
export default authSlice.reducer;
